import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import pickupDropoffInfo from './pickupDropoffInfo'
import carDetail from './carDetail'
import submitOrderInfo from './submitOrderInfo'
import confirmOrderInfo from './confirmOrder'
import fixedCarRental from './fixedCarRental'
import publishCar from './publishCar'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
      pickupDropoffInfo,
      carDetail,
      submitOrderInfo,
      confirmOrderInfo,
      fixedCarRental,
        publishCar
    },

    // 持久化插件
    plugins: [createPersistedState({
        storage: window.localStorage,
        reducer(val) {
            return {
                pickupDropoffInfo: val.pickupDropoffInfo,
                carDetail: val.carDetail,
                submitOrderInfo: val.submitOrderInfo,
                confirmOrderInfo: val.confirmOrderInfo,
                fixedCarRental: val.fixedCarRental,
            }
        }
    })]
})



// WEBPACK FOOTER //
// ./src/store/index.js